/** 解析可读时间入参：支持 Date、ISO、以及 "YYYY-MM-DD HH:mm:ss" */
export function parseReadableDate(input: string | Date): Date {
  if (input instanceof Date) return input;
  const s = String(input).trim();
  if (!s) return new Date(NaN);
  // ISO（含 T / Z / 偏移）：直接交给原生解析，勿把 `-` 换成 `/`
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
    return new Date(s);
  }
  // 业务约定 "YYYY-MM-DD HH:mm:ss"：换成 / 以兼容 Safari
  return new Date(s.replace(/-/g, "/"));
}

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

function formatHm(d: Date): string {
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/**
 * 将日期时间格式化为可读相对/绝对时间（客服/群聊系统时间条同一套规则）。
 * - 1 分钟内：刚刚
 * - 1 小时内：XX分钟前
 * - 当天：HH:mm
 * - 当年：M月D日 HH:mm
 * - 更早：YYYY年M月D日 HH:mm
 */
export function getReadableTime(input: string | Date, now: Date = new Date()): string {
  const d = parseReadableDate(input);
  if (Number.isNaN(d.getTime())) {
    return typeof input === "string" ? input : "";
  }

  const diffMs = now.getTime() - d.getTime();
  if (diffMs >= 0) {
    const diffSec = Math.floor(diffMs / 1000);
    if (diffSec < 60) return "刚刚";
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin}分钟前`;
  }

  const hm = formatHm(d);
  if (isSameDay(d, now)) return hm;

  const mo = d.getMonth() + 1;
  const day = d.getDate();
  if (d.getFullYear() === now.getFullYear()) return `${mo}月${day}日 ${hm}`;

  return `${d.getFullYear()}年${mo}月${day}日 ${hm}`;
}
